<div class="app-header">
  <div class="app-header__row">
    <div>
      <button
        class="app-header__button"
        [hidden]="!loggedInUser"
        mat-icon-button
        (click)="onButtonClick()"
        aria-label="profile menu">
        <mat-icon
          aria-hidden="false"
          aria-label="profile avatar or icon"
          svgIcon="menu">
        </mat-icon>
      </button>
      <span class="app-header__title"></span>
      <img
        class="app-header__logo"
        src="assets/static/inpool__white.svg"
        alt="InPool Logo" />
      <ng-container *ngIf="isDemo$ | async as isDemo">
        <ng-container *ngIf="demoInstanceNumber$ | async as instanceNumber">
          <div
            class="demo-tag"
            [matTooltip]="
              (demoValidUntil$ | async)
                ? ('demoValidUntil' | i18n) +
                  ': ' +
                  (demoValidUntil$ | async | date: 'dd.MM.yyyy')
                : ''
            ">
            Demo<span *ngIf="instanceNumber && instanceNumber > 1">
              {{ instanceNumber }}</span
            >
          </div>
        </ng-container>
      </ng-container>
    </div>
    <button
      *ngIf="isImpersonating$ | async"
      class="transparent-pill-button icon-right app-header__return-button"
      type="button"
      (click)="onReturnClick()"
      data-cy="header-return-button"
      aria-label="Zurück zum eigenen Benutzer">
      {{ ("returnToUser" | i18n) || "zurück zum Benutzer" | firstUppercase }}
      <mat-icon svgIcon="account-outline"></mat-icon>
    </button>
    <div
      *ngIf="
        (isDispo(loggedInUser) || isRequester(loggedInUser)) &&
        (canSwitchCustomer$ | async)
      ">
      <app-customer-switcher
        data-cy="header-customer-switcher"
        [loggedInUser]="loggedInUser"></app-customer-switcher>
    </div>
  </div>
</div>
